webpackJsonp([107818501498521],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SEO = __webpack_require__(21);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _pageModule = __webpack_require__(35);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  // return (
	  //   <div className={styles.container}>
	  //     <h1>{post.frontmatter.title}</h1>
	  //     <div dangerouslySetInnerHTML={{ __html: post.html }} />
	  //   </div>
	  // );
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: _pageModule2.default.container },
	    _react2.default.createElement(_SEO2.default, {
	      title: post.frontmatter.title
	      // image={post.frontmatter.image}
	    }),
	    _react2.default.createElement(
	      "h1",
	      null,
	      post.frontmatter.title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _pageModule2.default.date },
	      new Date(post.frontmatter.date).toLocaleDateString()
	    ),
	    _react2.default.createElement("div", { className: _pageModule2.default.description, dangerouslySetInnerHTML: { __html: post.html } })
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-eb07bf20dc0694dfb2e1.js